// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { onAuthStateChanged } from "firebase/auth";
import LoginPage from "./pages/LoginPage";
import EmployeesPage from "./pages/EmployeesPage";
import TimelinePage from "./pages/TimelinePage";
import './css/navbar.css'; // Uključi navbar.css

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = React.useState(null);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      if (!user) {
        navigate("/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  if (isAuthenticated === null) {
    return <div className="flex items-center justify-center min-h-screen"><p>Učitavanje...</p></div>;
  }

  return isAuthenticated ? children : null;
};

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    auth.signOut().then(() => {
      navigate("/login");
    });
  };

  return (
    <nav className="navbar">
      <div className="flex justify-center items-center w-full">
        <div className="flex space-x-6">
          <Link to="/employees" className={location.pathname === "/employees" ? "active" : ""}>Zaposlenici</Link>
          <Link to="/timeline" className={location.pathname === "/timeline" ? "active" : ""}>Timeline</Link>
        </div>
      </div>
      <button onClick={handleLogout} className="logout-btn">Odjava</button>
    </nav>
  );
};

function App() {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen"><p>Učitavanje...</p></div>;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {user && <Navbar />}
        <div className="w-[80%] mx-[10%] pt-4">
          <Routes>
            <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
            <Route
              path="/"
              element={user ? <TimelinePage /> : <Navigate to="/login" />}
            />
            <Route
              path="/timeline"
              element={user ? <TimelinePage /> : <Navigate to="/login" />}
            />
            <Route
              path="/employees"
              element={user ? <EmployeesPage /> : <Navigate to="/login" />}
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;